<template>
  <div class="web-panel-page">
    <div class="before" v-if="$slots.before">
      <slot name="before"></slot>
    </div>
    <div class="container">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { useWebPanel } from './hooks';
import { watch, inject } from '@vue/composition-api';

export default {
  name: 'WebPanelPage',
  props: {
    title: { required: true },
    focus: { type: Boolean },
    loading: { type: Boolean },
  },
  setup (props) {
    const {
      title,
      loading,
      focusMode,
    } = useWebPanel();
    watch(() => props.title, () => {
      title.value = props.title;
    });
    watch(() => props.loading, () => {
      loading.value = props.loading;
    });
    watch(() => props.focus, () => {
      focusMode.value = props.focus;
    });
    focusMode.value = props.focus;
    // notify parent webPanel that child page is attached
    const webPanelAPI = inject('webPanelAPI');
    webPanelAPI.notifyPageAttached();
    return {};
  },
};
</script>

<style lang="postcss">
@import "@sbvr/common/legacy-shared/styles";

.web-panel-page {
  width: 100%;
  margin: 0 auto;
  & .container {
    padding: 0 var(--spacingSm);
    @media (--desktop) {
      padding: 0 var(--spacingMd);
    }
    @media (--desktopXL) {
      padding: 0 var(--spacingXL);
    }
    padding-top: var(--spacingMd);
  }
  & .before + .container {
    padding-top: 0;
  }
}
</style>
